import http from 'hub-http/clients/apiClient';
export default function isHubContact() {
  return http.get('bizops-services-customers/v3/hub-contact-roles/external/is-hub-contact');
}